import { render, staticRenderFns } from "./ReadOnlyTable.vue?vue&type=template&id=967c037a&scoped=true&"
import script from "./ReadOnlyTable.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967c037a",
  null
  
)

export default component.exports